import type { Contact } from "../types";

/** "Voornaam Achternaam", without a trailing space when there is no last name. */
export const contactFullName = (contact?: Partial<Contact> | null): string =>
  contact
    ? [contact.first_name, contact.last_name].filter(Boolean).join(" ")
    : "";
